module.exports = __webpack_public_path__ + "static/media/teamitem_mangguo.ddd510af.png";